import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-after-account',
  templateUrl: './after-account.component.html',
  styleUrls: ['./after-account.component.css']
})
export class AfterAccountComponent implements OnInit {
  
  constructor(private router:Router){}
  ngOnInit(): void {
      setTimeout(() => {
        //// //console.log("Page Message de confirmation")

        this.router.navigateByUrl('/auth/login');

      },5000)
  }

}
